import { recModalOpen, recModalsClose } from "./modals";
import { btnUtils, isObject, makeToast } from "./utils";

export const sellerListingsInit = (queryString: URLSearchParams) => {

  const clearPreloginParams = () => {
    // Remove specific parameters to avoid redundant actions on refresh
    queryString.delete('preloginListingId');
    queryString.delete('preloginSellerUUID');
    queryString.delete('preloginListingProcessed');
    // Update URL with remaining parameters
    window.history.replaceState({}, "", window.location.pathname + (queryString.toString() ? '?' + queryString.toString() : ''));
  };

  const preloginListingId = localStorage.getItem('trove_preloginListingId');
  const preloginSellerUUID = localStorage.getItem('trove_preloginSellerUUID');
  const listingProcessed = queryString.get('preloginListingProcessed');

  if (preloginListingId && preloginSellerUUID) {
    localStorage.removeItem('trove_preloginListingId');
    localStorage.removeItem('trove_preloginSellerUUID');
    clearPreloginParams();
    // fetching the listings page again but with preloginListingId and preloginSellerUUID will allow the processPreloginDraft function to run
    if (!listingProcessed) {
      document.querySelector("#rec-message-process-prelogin")?.classList.remove("rec-hidden");
      window.location.href = `${recAppProxyConfig.paths.pathListings}&preloginListingId=${preloginListingId}&preloginSellerUUID=${preloginSellerUUID}`;
    }
  } else {
    clearPreloginParams();
  }
  /* Listings Status Toggle Utility */
  document
    .querySelectorAll(".rec-listings-toggle a")
    .forEach((thisElemToggle) => {
      thisElemToggle.addEventListener("click", (e) => {
        e.preventDefault();
        const target = e.currentTarget as HTMLAnchorElement;
        const thisListingCategory = target.getAttribute(
          "data-listing-category",
        );

        if (thisListingCategory !== null) {
          document
            .querySelectorAll(".rec-listings-toggle")
            .forEach((thisElemToggler) => {
              thisElemToggler.classList.remove("rec-listings-toggle-active");
            });

          target.parentElement?.classList.add("rec-listings-toggle-active");

          document
            .querySelectorAll(".rec-grid-item-listing[data-listing-category]")
            .forEach((thisElemTarget) => {
              const listingCategory = thisElemTarget.getAttribute(
                "data-listing-category",
              );
              if (
                thisListingCategory === "all" ||
                listingCategory === thisListingCategory
              ) {
                thisElemTarget.classList.remove("rec-hidden");
              } else {
                thisElemTarget.classList.add("rec-hidden");
              }
            });
        }
      });
    });

  /* Listen for click on a button to pause a listing */
  document
    .querySelectorAll(".rec-listing-pause")
    .forEach((thisRecPauseAction) => {
      thisRecPauseAction.addEventListener("click", async (e) => {
        e.preventDefault();
        const target = e.target as HTMLButtonElement;
        const listingId = thisRecPauseAction.getAttribute("data-listing");

        if (listingId !== null) {
          const recListingContainer = document.getElementById(
            "rec-listing-view-" + listingId,
          );

          if (recListingContainer) {
            btnUtils.loadingToggle(target);

            try {
              const listingPausePost = await fetch(
                recAppProxyConfig.paths.pathListingPausePost.replace(
                  "%lid%",
                  listingId,
                ),
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                },
              );

              const listingPausePostResponse = await listingPausePost.json();

              if (
                !listingPausePostResponse.errors &&
                isObject(listingPausePostResponse.data) &&
                "listing_status" in listingPausePostResponse.data
              ) {
                makeToast("toast-listing-paused");
                recListingContainer.setAttribute(
                  "data-listing-status",
                  listingPausePostResponse.data.listing_status,
                );
              } else {
                makeToast("toast-ajax-error");
              }
            } catch (error) {
              console.error("Error pausing listing:", error);
              makeToast("toast-ajax-error");
            } finally {
              btnUtils.reset();
            }
          } else {
            console.error(
              "recListingContainer not found for listingId:",
              listingId,
            );
          }
        } else {
          console.error("listingId is null");
        }
      });
    });

  /* Listen for click on a button to resume a listing */
  document
    .querySelectorAll(".rec-listing-resume")
    .forEach((thisRecResumeAction) => {
      thisRecResumeAction.addEventListener("click", async (e) => {
        e.preventDefault();
        const target = e.target as HTMLButtonElement;
        const listingId = thisRecResumeAction.getAttribute("data-listing");

        if (listingId !== null) {
          const recListingContainer = document.getElementById(
            "rec-listing-view-" + listingId,
          );

          if (recListingContainer) {
            btnUtils.loadingToggle(target);

            try {
              const listingResumePost = await fetch(
                recAppProxyConfig.paths.pathListingResumePost.replace(
                  "%lid%",
                  listingId,
                ),
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                },
              );

              const listingResumePostResponse = await listingResumePost.json();

              if (
                !listingResumePostResponse.errors &&
                isObject(listingResumePostResponse.data) &&
                "listing_status" in listingResumePostResponse.data
              ) {
                makeToast("toast-listing-resumed");
                recListingContainer.setAttribute(
                  "data-listing-status",
                  listingResumePostResponse.data.listing_status,
                );
              } else {
                makeToast("toast-ajax-error");
              }
            } catch (error) {
              console.error("Error resuming listing:", error);
              makeToast("toast-ajax-error");
            } finally {
              btnUtils.reset();
            }
          } else {
            console.error(
              "recListingContainer not found for listingId:",
              listingId,
            );
          }
        } else {
          console.error("listingId is null");
        }
      });
    });

  /* Listen for click on a button to cancel/remove a listing */
  document
    .querySelectorAll(".rec-listing-cancel")
    .forEach((thisRecCancelAction) => {
      thisRecCancelAction.addEventListener("click", async (e) => {
        const target = e.currentTarget as HTMLAnchorElement;
        const listingId = target.getAttribute("data-listing");
        const listingStatus = target.getAttribute("data-listing-status");
        const recCancelModalButton = document.getElementById(
          "rec-listing-cancel-confirmed",
        );
        const recListingContainer = document.getElementById(
          `rec-listing-view-${listingId}`,
        );

        if (
          listingId &&
          listingStatus &&
          recCancelModalButton &&
          recListingContainer
        ) {
          if (!target.classList.contains("rec-listing-cancel-confirmed")) {
            recCancelModalButton.setAttribute("data-listing", listingId);
            recCancelModalButton.setAttribute(
              "data-listing-status",
              listingStatus,
            );

            const cancelListingImage = document.querySelector(
              ".rec-cancel-listing-image img",
            ) as HTMLImageElement;
            const listingImage = recListingContainer.querySelector(
              ".rec-grid-item-image img",
            ) as HTMLImageElement;
            const cancelListingInfoTitle = document.querySelector(
              ".rec-cancel-listing-info-title",
            ) as HTMLHeadingElement;
            const listingTitle = recListingContainer.querySelector(
              ".rec-grid-item-title-product",
            ) as HTMLHeadingElement;

            if (
              cancelListingImage &&
              listingImage &&
              cancelListingInfoTitle &&
              listingTitle
            ) {
              cancelListingImage.setAttribute("src", listingImage.src);
              cancelListingInfoTitle.innerHTML = listingTitle.innerHTML;
            }
          } else {
            e.preventDefault();
            btnUtils.loadingToggle(e.target as HTMLAnchorElement);

            try {
              const listingCancelPost = await fetch(
                recAppProxyConfig.paths.pathListingCancelPost.replace(
                  "%lid%",
                  listingId,
                ),
                {
                  method: "POST",
                  body: JSON.stringify({ listing_status: listingStatus }),
                  headers: { "Content-Type": "application/json" },
                },
              );

              const listingCancelPostResponse = await listingCancelPost.json();

              if (
                !listingCancelPostResponse.errors &&
                isObject(listingCancelPostResponse.data) &&
                "listing_status" in listingCancelPostResponse.data
              ) {
                recModalsClose();
                makeToast("toast-listing-cancelled");
                recListingContainer.parentNode?.removeChild(
                  recListingContainer,
                );
                target.removeAttribute("data-trigger-cancel");
              } else {
                makeToast("toast-ajax-error");
              }
            } catch (error) {
              console.error("Error cancelling listing:", error);
              makeToast("toast-ajax-error");
            } finally {
              btnUtils.reset();
            }
          }
        } else {
          console.error("Required elements or attributes are missing.");
        }
      });
    });

  /* Look for special remove parameter and if we have a cancel button that is ready to be auto clicked */
  if (
    queryString.has("remove") &&
    document.querySelector("[data-trigger-cancel]")
  ) {
    recModalOpen("rec-modal-cancel-confirm");
  }
};